// チームカラー: コントラスト比計算ユーティリティ

// グローバルユーティリティ（team_edit.js / team_bulk_info_edit.js / team_setup_assignment.js から利用）
window.TeamColorContrast = {
  MINIMUM_RATIO: 1.8,

  // 白(#FFFFFF)に対するWCAGコントラスト比を計算
  ratioWithWhite: function(hex) {
    if (!hex || !/^#[0-9A-Fa-f]{6}$/.test(hex)) return 1.0;

    var r = parseInt(hex.substr(1, 2), 16) / 255.0;
    var g = parseInt(hex.substr(3, 2), 16) / 255.0;
    var b = parseInt(hex.substr(5, 2), 16) / 255.0;

    var rgb = [r, g, b].map(function(c) {
      return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    });

    var luminance = 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];
    return 1.05 / (luminance + 0.05);
  },

  // コントラスト比が十分かどうか
  isSufficient: function(hex) {
    return this.ratioWithWhite(hex) >= this.MINIMUM_RATIO;
  }
};
